var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "purchase"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29491",
    "data-name": "Rectangle 29491",
    width: 14,
    height: 14,
    transform: "translate(39 429)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_710",
    "data-name": "Mask Group 710",
    transform: "translate(-39 -429)",
    clipPath: "url(#purchase)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_14_",
    "data-name": "svgexport-6 (14)",
    transform: "translate(39 429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12961",
    "data-name": "Path 12961",
    d: "M10.667,7.583a3.792,3.792,0,1,1,3.792-3.792A3.8,3.8,0,0,1,10.667,7.583Zm0-7a3.208,3.208,0,1,0,3.208,3.208A3.212,3.212,0,0,0,10.667.583Z",
    transform: "translate(-0.458)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12962",
    "data-name": "Path 12962",
    d: "M10.208,5.417A.294.294,0,0,1,10,5.331L8.835,4.165a.292.292,0,0,1,.412-.412l.946.946L12.03,2.6a.292.292,0,1,1,.439.384L10.427,5.317a.29.29,0,0,1-.209.1h-.01Z",
    transform: "translate(-0.583 -0.167)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12963",
    "data-name": "Path 12963",
    d: "M11.542,10.167H3.958a.292.292,0,0,1-.286-.234L2.506,4.1a.291.291,0,0,1,.286-.349H5.125a.292.292,0,0,1,0,.583H3.148L4.2,9.583h7.1l.162-.808a.3.3,0,0,1,.343-.229.292.292,0,0,1,.229.343l-.208,1.042A.293.293,0,0,1,11.542,10.167Z",
    transform: "translate(-0.167 -0.25)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12964",
    "data-name": "Path 12964",
    d: "M3.791,10a.292.292,0,0,1-.285-.235L2.06,2.536a.877.877,0,0,0-.858-.7H.292a.292.292,0,0,1,0-.583H1.2a1.462,1.462,0,0,1,1.43,1.173l1.445,7.23a.291.291,0,0,1-.229.343A.268.268,0,0,1,3.791,10Z",
    transform: "translate(0 -0.083)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12965",
    "data-name": "Path 12965",
    d: "M12.667,11.75H2.75a.875.875,0,1,1,0-1.75H3.917a.292.292,0,0,1,0,.583H2.75a.292.292,0,1,0,0,.583h9.917a.292.292,0,1,1,0,.583Z",
    transform: "translate(-0.125 -0.667)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12966",
    "data-name": "Path 12966",
    d: "M4.917,14.833a1.167,1.167,0,1,1,1.167-1.167A1.168,1.168,0,0,1,4.917,14.833Zm0-1.75a.583.583,0,1,0,.583.583A.584.584,0,0,0,4.917,13.083Z",
    transform: "translate(-0.25 -0.833)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12967",
    "data-name": "Path 12967",
    d: "M10.542,14.833a1.167,1.167,0,1,1,1.167-1.167A1.168,1.168,0,0,1,10.542,14.833Zm0-1.75a.583.583,0,1,0,.583.583A.584.584,0,0,0,10.542,13.083Z",
    transform: "translate(-0.625 -0.833)",
    fill: "#6a6f73",
    stroke: "#6a6f73",
    strokeWidth: 0.2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.69e582a69b104e7d0cc57da48c4e752a.svg";
export { ForwardRef as ReactComponent };